angular.module('core')
  .service('dblPrintService', [
    '$window',
  function(
    $window
  ) {
    // This service manages programmatic printing of reports via a printSection dom node.
    // Most of the original code in this service was moved from print-section.js

    var printNotificationSubject;

    var afterPrint = function () {
        $('body').removeClass('scoped-print');
        // start afresh after print - for some cases, doing so before print wasn't working
        $('#printSection').remove();

        if (printNotificationSubject) {
            printNotificationSubject.onCompleted();
        }
    };

    // create/clear the dom node that will contain the report
    var resetPrintSection = function () {
        var printSection = $('#printSection');

        // if there is no print section, create one
        if (!printSection.length) {
            printSection = $('<div></div>').attr('id', 'printSection').appendTo('body');
        }

        // start afresh
        printSection.html('');

        return printSection;
    };

    // print the contents of the print section
    var print = function() {
        // Only add this class when the print button is used
        // We don't want to only show report when user uses print from the browser
        $('body').addClass('scoped-print');

        $window.print();
    };

    // populate the print section with content and print it
    // Returns an Rx observable that completes when the afterPrint event is triggered.
    var printElement = function(element, shouldAddLogo, shouldAddBreadcrumbs, shouldClone, shouldSetWidth) {
        printNotificationSubject = new Rx.Subject();
        var printSection = resetPrintSection();

        if (shouldAddLogo) {
            $('#logo').clone().appendTo(printSection);
        }
        if (shouldAddBreadcrumbs) {
            $('#report-breadcrumb-container').clone().appendTo(printSection);
        }

        var contentToPrint = shouldClone ? element.clone() : element;
        contentToPrint.appendTo(printSection);

        if (shouldSetWidth) {
            // Explicitly set the clone width to its source element's width.
            // This is at least useful for a report that contains a highchart
            // since the highchart doesn't seem to redraw to fit the width of the clone.
            contentToPrint.css('width', $(element).css('width'));
        }

        print();

        return printNotificationSubject;
    };

    if ($window.matchMedia) {
        var mediaQueryList = $window.matchMedia('print');
        mediaQueryList.addListener(function(mql) {
            if (!mql.matches) {
                afterPrint();
            }
        });
    }

    $window.onafterprint = afterPrint;

    _.extend(this, {
        resetPrintSection: resetPrintSection,
        printElement: printElement
    });

}]);
